import accountingSummary from './accountingSummary';
import AccountingYearlyManagement from './AccountingYearlyManagement';

export default (siteName) => [
    // ------------------- 會計功能 -------------------
    // 年度會計總管理
    ...AccountingYearlyManagement(siteName),

    // 帳務匯總表
    ...accountingSummary(siteName),

    // 會計科目設定
    {
        path: 'accounting-setting',
        name: 'accounting-setting',
        component: () => import('../../components/dashboard/Accounting/AccountingSetting/indexPage.vue'),
        meta: {
            title: `會計科目設定${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 會計科目對照表
    {
        path: 'accounting-relation-setting',
        name: 'accounting-relation-setting',
        component: () => import('../../components/dashboard/Accounting/AccountingRelationSetting/indexPage.vue'),
        meta: {
            title: `會計科目對照表${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 綜合損益表
    {
        path: 'accounting-statement',
        name: 'accounting-statement',
        component: () => import('../../components/dashboard/Accounting/AccountingStatement/indexPage.vue'),
        meta: {
            title: `綜合損益表${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 專案綜合損益表
    {
        path: 'project-accounting-statement',
        name: 'project-accounting-statement',
        component: () => import('../../components/dashboard/Accounting/AccountingStatement/ProjectAccountingStatementPage.vue'),
        meta: {
            title: `專案綜合損益表${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 傳票作業清單
    {
        path: 'accounting-voucher-list',
        name: 'accounting-voucher-list',
        component: () => import('../../components/dashboard/Accounting/AccountingVoucherList/indexPage.vue'),
        meta: {
            title: `傳票作業清單${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 會計科目餘額試算表
    {
        path: 'accounting-account-balance-spreadsheet',
        name: 'accounting-account-balance-spreadsheet',
        component: () => import('../../components/dashboard/Accounting/AccountingAccountBalanceSpreadsheet/indexPage.vue'),
        meta: {
            title: `會計科目餘額試算表${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 會計科目總分類帳
    {
        path: 'accounting-general-ledger',
        name: 'accounting-general-ledger',
        component: () => import('../../components/dashboard/Accounting/AccountingGeneralLedger/indexPage.vue'),
        meta: {
            title: `會計科目總分類帳${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 會計科目總分類帳
    {
        path: 'accounting-general-ledger-empty',
        name: 'accounting-general-ledger-empty',
        component: () => import('../../components/dashboard/Accounting/AccountingGeneralLedger/EmptyAccnoPage.vue'),
        meta: {
            title: `會計科目總分類帳${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 會計資產負債表
    {
        path: 'accounting-balance-sheet',
        name: 'accounting-balance-sheet',
        component: () => import('../../components/dashboard/Accounting/AccountingBalanceSheet/indexPage.vue'),
        meta: {
            title: `會計資產負債表${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 專案資產負債表
    {
        path: 'project-accounting-balance-sheet',
        name: 'project-accounting-balance-sheet',
        component: () => import('../../components/dashboard/Accounting/AccountingBalanceSheet/ProjectAccountingBalanceSheetPage.vue'),
        meta: {
            title: `會計資產負債表${siteName}`,
            activeMenu: 'accounting',
        },
    },
    // 會計傳票列印
    {
        path: 'accounting-voucher-print/:vono',
        name: 'accounting-voucher-print',
        component: () => import('../../components/dashboard/Accounting/AccountingVoucherList/VoucherPrintPage.vue'),
        meta: {
            title: `會計傳票列印${siteName}`,
            activeMenu: 'accounting',
        },
    },
    {
        path: 'accounting-vouchers-print/:UNT_NBR',
        name: 'accounting-vouchers-print',
        component: () => import('../../components/dashboard/Accounting/AccountingVoucherList/VoucherPrintPage.vue'),
        meta: {
            title: `會計傳票列印${siteName}`,
            activeMenu: 'accounting',
        },
    },

    // ------------------- 申報幫手 -------------------
    {
        path: 'accounting-business-tax',
        name: 'accounting-business-tax',
        component: () => import('../../components/dashboard/Accounting/BusinessTax/indexPage.vue'),
        meta: {
            title: `營業稅申報${siteName}`,
            activeMenu: 'declaration',
        },
        children: [
            {
                path: 'summary',
                name: 'accounting-business-tax-summary',
                component: () => import('../../components/dashboard/Accounting/BusinessTax/SummaryTablePage.vue'),
                meta: {
                    title: `營業稅快速申報幫手 ${siteName}`,
                    activeMenu: 'declaration',
                },
            },
            {
                path: 'step1',
                name: 'accounting-business-tax-quick-declare-step-1',
                component: () => import('../../components/dashboard/Accounting/BusinessTax/QuickDeclareStep1.vue'),
                meta: {
                    title: `營業稅快速申報幫手 ${siteName}`,
                    activeMenu: 'declaration',
                },
            },
            {
                path: 'step2',
                name: 'accounting-business-tax-quick-declare-step-2',
                component: () => import('../../components/dashboard/Accounting/BusinessTax/QuickDeclareStep2.vue'),
                meta: {
                    title: `營業稅快速申報幫手 ${siteName}`,
                    activeMenu: 'declaration',
                },
            },
            {
                path: 'step3',
                name: 'accounting-business-tax-quick-declare-step-3',
                component: () => import('../../components/dashboard/Accounting/BusinessTax/QuickDeclareStep3.vue'),
                meta: {
                    title: `營業稅快速申報幫手 ${siteName}`,
                    activeMenu: 'declaration',
                },
            },
            {
                path: 'step4',
                name: 'accounting-business-tax-quick-declare-step-4',
                component: () => import('../../components/dashboard/Accounting/BusinessTax/QuickDeclareStepSummary.vue'),
                meta: {
                    title: `營業稅快速申報幫手 ${siteName}`,
                    activeMenu: 'declaration',
                },
            },
        ],
    },
    {
        path: 'accounting-personal-services-tax',
        name: 'accounting-personal-services-tax',
        component: () => import('../../components/dashboard/Accounting/PersonalServicesTax/indexPage.vue'),
        meta: {
            title: `勞務稅申報${siteName}`,
            activeMenu: 'declaration',
        },
    },
    {
        path: 'accounting-annual-tax',
        name: 'accounting-annual-tax',
        component: () => import('../../components/dashboard/Accounting/AnnualTax/indexPage.vue'),
        meta: {
            title: `年度扣繳申報${siteName}`,
            activeMenu: 'declaration',
        },
    },
    {
        path: 'application-form-management',
        name: 'application-form-management',
        component: () => import('../../components/dashboard/Accounting/ApplicationFormManagement/indexPage.vue'),
        meta: {
            title: `申報文件管理${siteName}`,
            activeMenu: 'declaration',
        },
    },
];
